import '../styles/componentStyles/ValueTile.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import { isMissingChartValue } from '../utils/chartDataAvailability';
import { HelpButton } from './HelpButton';

function CircleValueTile({
  id,
  title,
  value,
  data,
  icon,
  colour,
  width,
  modalText,
  openModal,
  withIcon,
  goalTitle,
  textValue,
  units,
  maxValue,
}) {
  const { t } = useTranslation();
  const tileValue = withIcon ? data : textValue;
  const dataAvailable = !isMissingChartValue(tileValue);

  return (
    <section
      role="group"
      aria-labelledby={`${id}-region-title`}
      className={`chart-container tile ${width}`}
    >
      <span className="srOnly" id={`${id}-region-title`}>
        {`${goalTitle} - ${title}`}
      </span>
      <div className="title-container">
        <h3 id={`${id}-title`} className="title fs-exclude">
          {title}
        </h3>
        {modalText && (
          <HelpButton
            id={id}
            referenceId={`${id}-title`}
            onClick={() => openModal(title, modalText, `${id}-help-button`)}
          />
        )}
      </div>
      <div className="chart-box" aria-labelledby={`${id}-region-data`} role="group">
        <span className="srOnly" id={`${id}-region-data`} aria-hidden="true">
          {!withIcon &&
            dataAvailable &&
            !maxValue &&
            `${t('hydration.circleValueTile.yourResult', { result: title })} ${textValue}${units && ` ${units}`} ${value}`}
          {!withIcon &&
            dataAvailable &&
            maxValue &&
            `${t('goal.circleValueTile.yourScore')} ${textValue}${units && ` ${units}`}${maxValue && ` ${t('goal.circleValueTile.maxValue')} ${maxValue}`}`}
          {withIcon && dataAvailable && `${t('goal.circleValueTile.yourScore')} ${data} ${value}`}
          {!dataAvailable && t('D075')}
        </span>
        <div className="circle_chart fs-exclude" aria-hidden="true">
          {!withIcon && dataAvailable && (
            <>
              <p style={{ color: colour }}>
                {textValue}
                {units && <span style={{ color: colour }}>{units}</span>}
              </p>
              <div className="value-descr">
                {maxValue ? `${value} ${t('D216')} ${maxValue}` : `${value}`}
              </div>
            </>
          )}
          {withIcon && dataAvailable && (
            <>
              <FontAwesomeIcon style={{ color: colour }} icon={icon} className=" icon tile" />
              <p style={{ color: colour }}>{data}</p>
              <div style={{ color: colour }} className="value-descr caps">
                {value}
              </div>
            </>
          )}
          {!dataAvailable && <div className="chart-no-data nd-tile">{t('D075')}</div>}
        </div>
      </div>
    </section>
  );
}

export default CircleValueTile;
